import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

type JswDoubleFeatureCardProps = {
    readonly title: string;
    readonly description: string;
    readonly image: string;
};

const cardStyle = css({
    display: "flex",
    flexDirection: "column",
    height: "638px",
    width: "569px",
    padding: "token('space.0')",
    gap: "23.157px",
    flexShrink: "0",
    background: "#FFF",
    boxShadow:
        "0px 1px 1px 0px rgba(9, 30, 66, 0.25), 0px 0px 1px 0px rgba(9, 30, 66, 0.31)",
    [media.below.lg]: {
        maxWidth: "600px",
        width: "100%",
        height: "100%",
        alignItems: "center",
        paddingBlockEnd: "25px"
    }
});

const imageStyles = css({
    width: "100%",
    height: "100%"
});

const textStyles = css({
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    alignItems: "center"
});

const titleStyles = css({
    color: "#000",
    textAlign: "center",
    fontFeatureSettings: "'clig' off, 'liga' off",
    fontFamily: "var(--bxp-charlie-display-font-family)",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "30px"
});

const descriptionStyles = css({
    color: "#000",
    textAlign: "center",
    fontFeatureSettings: "'clig' off, 'liga' off",
    fontFamily: "var(--bxp-charlie-text-font-family)",
    fontSize: "15.438px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "23.157px",
    marginBlockStart: "8px",
    width: "442px",
    padding: "0 25px",
    [media.below.lg]: {
        width: "100%"
    }
});

export const JswDoubleFeatureCard = ({
    title,
    description,
    image
}: JswDoubleFeatureCardProps) => {
    return (
        <div css={cardStyle}>
            <div>
                <img css={imageStyles} src={image} alt={title} />
            </div>
            <div css={textStyles}>
                <div css={titleStyles}>{title}</div>
                <div css={descriptionStyles}>{description}</div>
            </div>
        </div>
    );
};
